import {inject, Injectable} from '@angular/core';
import {LazyPhraseService} from '@im-ng/text';
import {renderIcon} from '@js-dot/ui';
import {DotTranslateService} from '@ng-dot/text';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {TextActPhrase} from './text-act-phrase';
import {TEXT_ACT} from './text-act-tokens';
import {TEXT_ACTINGS} from './text-actings';

const CACHE: Record<string, Observable<string>> = {};

@Injectable({
	providedIn: 'root'
})
export class TextActService {
	protected _translate = inject(DotTranslateService);
	protected _phrase    = inject<LazyPhraseService<TextActPhrase>>(LazyPhraseService).load('global-as');

	configures: any;

	constructor() {
		const actings   = TEXT_ACTINGS;
		const overwrite = inject<Record<string, string | [string, string]>>(TEXT_ACT, {optional: true});

		if (overwrite) {
			for (let key in overwrite) {
				if (!overwrite.hasOwnProperty(key)) {
					continue;
				}
				const value = overwrite[key];
				if (typeof value === 'string') {
					actings[key][0] = value;
				} else {
					actings[key] = value;
				}
			}
		}

		this.configures = actings;
	}

	get(value: string, acting: keyof typeof TEXT_ACTINGS, icon?: boolean | string): any {
		const {_translate, _phrase, configures} = this;

		if (!(acting in configures)) {
			console.debug('찾을 수 없음', acting);
			return value;
		}

		const [icon_, phraseId] = configures[acting];

		const cacheKey = value + ':' + acting;

		if (icon === undefined && cacheKey in CACHE) {
			return CACHE[cacheKey];
		}

		return _phrase.load$
			.pipe(map(
				() => {
					const label = value ?
						_phrase.get(
							'$' + phraseId,
							_translate.word(value)
						) :
						_phrase.get(phraseId);

					if (icon === false) {
						return label;
					}


					const html = renderIcon(
						icon ?
							typeof icon === 'boolean' ?
								icon_ :
								icon :
							icon_,
						label
					);

					if (icon === undefined) {
						CACHE[cacheKey] = of(html);
					}

					return html;
				}));
	}
}